<template>
<transition name="slide-fade">
    <div
    class="alert"
    v-if="visible"
    :class="typeClass"
    role="alert">

        <button type="button"
            class="close focus:outline-none absolute top-0 right-0 py-1 px-2 text-xl"
            aria-label="Close"
            @click="hide">
            <span aria-hidden="true">&times;</span>
        </button>

        <div class="flex">
            <div class="py-1">
                <slot name="icon"></slot>
            </div>
            <div class="mr-4">
                <slot />
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    name: 'notification',
    props: {
        type: {
            type: String,
            default: 'error'
        },
        duration: {
            type: Number,
            default: 60000
        }
    },

    data: () => ({
        visible: false,
    }),

    mounted() {
        this.show()
    },

    computed: {
        typeClass() {
            switch(this.type) {
                case 'info':
                    return 'bg-white border-blue-700 text-blue-700'

                case 'success':
                    return 'bg-white border-green text-green'

                case 'error':
                default:
                    return 'bg-white border-red text-red'
            }
        }
    },

    methods: {
        show() {
            this.visible = true;
            setTimeout(this.hide, this.duration);
        },
        hide() {
            this.visible = false
        },
    }
}
</script>
